import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cirque du Soleil blew my mind",
  "description": "",
  "published": "2014-01-16T00:00:00.000Z",
  "redirect_from": ["/blog/cirque-du-soleil-blew-my-mind/swizec/6489"],
  "categories": "Amaluna, Circus, Cirque du Soleil, Performing Arts, San Francisco, Soleil, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`"Anyone interested in seeing this?", one of the guys shared a link on HipChat.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.cirquedusoleil.com/",
        "title": "Cirque du Soleil"
      }}>{`Cirque du Soleil's`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.cirquedusoleil.com/en/shows/amaluna/default.aspx",
        "title": "Amaluna"
      }}>{`Amaluna`}</a>{` playing for the last weekend at `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7783333333,-122.389444444&spn=0.01,0.01&q=37.7783333333,-122.389444444%20(AT%26T%20Park)&t=h",
        "title": "AT&T Park"
      }}>{`AT&T park`}</a>{` in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7833333333,-122.416666667&spn=0.1,0.1&q=37.7833333333,-122.416666667%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{`.`}</p>
    <p>{`"Yeah sure, I'll go.", I said with a deadpan expression.`}</p>
    <p>{`I'd been to like three circuses in my life and I had fun every time. Even that one time I watched a kid from the audience sit on a tortoise on stage for no reason.`}</p>
    <p>{`Cirque du Soleil is supposed to be the best circus in the world, so hey, why not? Not like I'm getting another chance any time soon ...`}</p>
    <p>{`And boy oh boy did I have `}<em parentName="p">{`no`}</em>{` idea the spectacle I was getting myself into. This was no circus, this was entertainment porn.`}</p>
    <p>{`When we finally reached the entrance on Sunday we were running late. Literally. We were running because not only were we late to AT&T park itself, the show was actually in an enormous `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Circus",
        "title": "Circus"
      }}>{`circus tent`}</a>{` in the parking lot across some sort of small river. We even missed the entrance and had to do full circle around the tent complex.`}</p>
    <p>{`We are not smart men.`}</p>
    <p>{`Step in the tent and it's a completely different class of circus. Nothing like that small traveling troupe you can see playing at the supermarket parking lot of your home town.`}</p>
    <p>{`Everything from proper concession stands, to well dressed bartenders and people guiding you to your seat. The concession stands even take credit cards and give receipts! I've had more trouble getting receipts from brick&mortar establishments than I did in this traveling tent.`}</p>
    <p>{`Then again, we did pay $90 per ticket ...`}</p>
    <p>{`The show itself was just ... magic. It really was. Words cannot explain how enthralled I was. I'm going to try anyway.`}</p>
    <p>{`When we took our seats there were girls in bright costumes doing acrobatics on top of some dudes. Using the dudes as stands that is, feet on feet, feet on hands. The whole shebang. They jumped from one guy to another, one even did a sort of summersault through a small human pyramid.`}</p>
    <p>{`From one dude to another, of course. Never touching the ground.`}</p>
    <p>{`Oh and they were twirling some sort of rope with big shiny weights. Because that's totally a thing. Let's not only perform acrobatics without touching the ground, let's add some twirling as well.`}</p>
    <p>{`You'd expect a break between acts. A narrator to come in and announce the next performer and act and to amp you up. The proverbial circus master with a megaphone, a big belly, bright red frock, and too much make up.`}</p>
    <p>{`Nope. None of that at Cirque du Soleil.`}</p>
    <p>{`Just a neverending stream of entertainment and the stage changing and the music never stopping and acts flowing one into another so seamlessly that performers adjust the stage for the next act `}<em parentName="p">{`while dancing`}</em>{`.`}</p>
    <p>{`Before I could bat an eyelid, intermission. Bam. Gob smacked! How is it possible for an hour to go by quicker than you can think `}<em parentName="p">{`"Wow that's really cool how they're doing that thing they're doing"`}</em>{`.`}</p>
    <p>{`After intermission the show went on. Immediately. Violently. Breathtakingly.`}</p>
    <p>{`No transition. No narrator. Nothing. Bam! You're back in the magic as if you'd never left. As if intermission never happened. As if you never left your seat.`}</p>
    <p>{`Performers pick you up in a whirlwind of magic and human bodies stretched to their limits. Humanity at its finest.`}</p>
    <p>{`Daredevil feats of agility and endurance and dexterity and beauty and eye candy and all wrapped up in a magnificent performance that will leave you breathless. Even the all girl rock band never stops playing. Not for a second.`}</p>
    <p>{`And then it's over.`}</p>
    <p>{`Up and up and up you go and just as you'd expect the bass to drop, the lights come on. The magic is over. You sit there, dazed and confused. What just happened? Did I really just spend three hours of my life in this uncomfortable chair without even noticing?`}</p>
    <p>{`You stagger home. Forever different, but somehow the same. That night your workout is twice as vigorous as usual.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=29cccde4-3e47-4d80-a4b3-330968345846",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      